import React from 'react';
import { SkeletonContainer, ImageSkeleton } from '../styled';

const WidgetSkeleton = () => {
    return (
        <SkeletonContainer
            background={'transparent'}
            padding={'0'}
            overflow={'initial'}
        >
            <ImageSkeleton radius={'4px'} aspectRatio={'4/3'} />
        </SkeletonContainer>
    );
};

export default WidgetSkeleton;
